/** Jax AbilitySpec seed kit (wiki-aligned numeric batch 3). */
export const JAX_ABILITY_DEFS = [
  {
    id: 'jax_q',
    champKey: 'jax',
    slot: 'Q',
    name: 'Leap Strike',
    targeting: 'targeted',
    range: 700,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 8,
    manaCost: 50,
    vfxId: 'jax_q',
    status: 'wired'
  },
  {
    id: 'jax_w',
    champKey: 'jax',
    slot: 'W',
    name: 'Empower',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 7,
    duration: 10,
    manaCost: 30,
    vfxId: 'jax_w',
    status: 'wired'
  },
  {
    id: 'jax_e',
    champKey: 'jax',
    slot: 'E',
    name: 'Counter Strike',
    targeting: 'aoe_self',
    range: 375,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: 375,
    cooldown: 17,
    duration: 2,
    manaCost: 50,
    vfxId: 'jax_e',
    cc: { type: 'stun', duration: 1 },
    status: 'wired'
  },
  {
    id: 'jax_r',
    champKey: 'jax',
    slot: 'R',
    name: 'Grandmaster-At-Arms',
    targeting: 'self_buff',
    range: 0,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 375,
    cooldown: 110,
    duration: 8,
    manaCost: 100,
    vfxId: 'jax_r',
    status: 'wired'
  }
];
